import { AppConfig } from '@app/app.config';
import { Subject } from 'rxjs';
import {
    OpenIdConfiguration,
    StsConfigHttpLoader,
} from 'angular-auth-oidc-client';

/**
 * Factory function that creates and configures an OpenID Connect (OIDC) authentication loader
 * for the management module.
 *
 * @param {AppConfig} appConfig - The application configuration service containing OAuth settings
 * @returns {StsConfigHttpLoader} An HTTP-based configuration loader for OIDC authentication
 *
 * @description
 * This function:
 * - Creates a Subject to emit OpenID configuration
 * - Loads the application configuration asynchronously
 * - Configures OIDC with authority, redirect URL, and secure routes
 * - Returns an StsConfigHttpLoader that manages the authentication configuration stream
 */
export const managementAuthFactory = (appConfig: AppConfig) => {
    const configObserver = new Subject<OpenIdConfiguration>();
    appConfig.load().then(() => {
        configObserver.next({
            authority: appConfig.managementOAuthAuthority,
            responseType: 'code',
            scope: 'openid',
            clientId: appConfig.managementOAuthClientId,
            redirectUrl: window.location.origin + '/management/callback',
            secureRoutes: [appConfig.managementApiUrl ?? ''],
            silentRenew: true,
            useRefreshToken: true,
            unauthorizedRoute: '/',
        });
    });
    return new StsConfigHttpLoader(configObserver);
};
